import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "Nazov", 'caption':"Názov", 'filter': 'string'},
]

function InstrumentStates(props) {
    const initialFilters = [
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Meno',
        }
    ]

    const baseUrl = '/instrument/instrument_states'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `/instruments/instrument_state/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/instrument_states/instrument_state`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Stavy Prístrojov"}
        />
    )
}

export default InstrumentStates
